import { render, staticRenderFns } from "./DashboardFeatured.vue?vue&type=template&id=a8a414ae&scoped=true&"
import script from "./DashboardFeatured.vue?vue&type=script&lang=js&"
export * from "./DashboardFeatured.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeatured.scss?vue&type=style&index=0&id=a8a414ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a414ae",
  null
  
)

export default component.exports